export default "assets/images/waves-0a39214e.svg";